import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import TabelHeader from './components/TabelHeader.vue';
import EditTable from './components/EditTable.vue';
import TabelToolBar from './components/TabelToolBar';
import { ExportPartBarcodeData } from '@/api/DeliveryCode';
import util from '@/libs/util';
export default {
  components: {
    TabelHeader: TabelHeader,
    EditTable: EditTable,
    TabelToolBar: TabelToolBar
  },
  data: function data() {
    return {
      isShowTabelHeader: false,
      TabelHeaderData: null,
      onSaveID: null,
      pageInfo: {
        TotalCount: null,
        PageSize: 10,
        PageIndex: 1
      }
    };
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(value) {
      this.$refs.EditTable.handleCurrentChange(value);
    },
    handleSizeChange: function handleSizeChange(value) {
      this.$refs.EditTable.handleSizeChange(value);
    },
    // cb获取标签列表
    cbGetPartBarcodeDetailList: function cbGetPartBarcodeDetailList(resolve) {
      this.pageInfo.TotalCount = resolve.data.TotalCount;
      this.pageInfo.PageSize = resolve.data.PageSize;
      this.pageInfo.PageIndex = resolve.data.PageIndex;
    },
    // cb切换单据
    cbNextOrder: function cbNextOrder(info, STATUS) {
      console.log('info', info);
      console.log('STATUS', STATUS);
      this.onSaveID = info.ID;
      this.$refs.EditTable.GetPartBarcodeDetailList(info);
      this.$refs.TabelToolBar.setStatus(STATUS);
    },
    // 上一张
    getBackOrder: function getBackOrder() {
      this.$refs.TabelHeader.getBackUpdata();
    },
    // 下一张
    nextOrder: function nextOrder() {
      this.$refs.TabelHeader.nextOrderUpdata();
    },
    // 明细导出
    onHandleDetailExport: function onHandleDetailExport() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  // MST_ID:this.TabelHeaderData.ID,
                  MST_ID: _this.onSaveID ? _this.onSaveID : _this.$refs.TabelHeader.getData().ID,
                  BARCODE_TYPE: 1 // Page:1,
                  // Limit:999

                };
                _context.next = 3;
                return ExportPartBarcodeData(params);

              case 3:
                res = _context.sent;

                if (res.code === 0) {
                  window.open(_this.$store.getters.getVUE_APP_DOWN + res.data);
                } else {
                  _this.$message.warning('数据导出失败----' + res.message);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 点击返回
    onHandleBlackBtn: function onHandleBlackBtn() {
      var _this2 = this;

      // console.log('$DeliveryCodeOrderState',this.$DeliveryCodeOrderState);
      if (this.$DeliveryCodeOrderState === 'addOrder' || this.$DeliveryCodeOrderState === 'editOrder') {
        this.$confirm('返回不会保存已修改的明细, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.$setOrderStatu('listShow');

          _this2.$emit('cbOnHandleBlackBtn');
        }).catch(function () {
          _this2.$message.warning('已取消');
        });
      } else if (this.$DeliveryCodeOrderState === 'orderShow') {
        this.$setOrderStatu('listShow');
        this.$emit('cbOnHandleBlackBtn');
      }
    },
    // 点击修改
    handleEditOrder: function handleEditOrder() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, vali;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _this3.onSaveID ? _this3.onSaveID : _this3.TabelHeaderData.ID;
                _context2.next = 3;
                return _this3.$refs.EditTable.valiPrintParBarcodeGroup(id);

              case 3:
                vali = _context2.sent;
                console.log('vali', vali);

                if (vali === true) {
                  // this.$refs.TabelHeader.PrintParBarcodeGroup()
                  _this3.$message.warning('已生成标签，不能修改');
                } else {
                  _this3.$setOrderStatu('editOrder');
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 点击单号打印
    handleRowPrint: function handleRowPrint(row) {
      this.$refs.TabelHeader.PrintRowOuterBoxLabel(row);
    },
    // 保存成功ID回调
    cbID: function cbID(id) {
      this.onSaveID = id;
      this.$refs.EditTable.setID(id);
    },
    // 组合打印内箱标签
    onHandlePrintParBarcodeGroup: function onHandlePrintParBarcodeGroup() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, vali;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = _this4.onSaveID ? _this4.onSaveID : _this4.TabelHeaderData.ID;
                _context3.next = 3;
                return _this4.$refs.EditTable.valiPrintParBarcodeGroup(id);

              case 3:
                vali = _context3.sent;
                console.log('vali', vali);

                if (vali === true) {
                  _this4.$refs.TabelHeader.PrintParBarcodeGroup();
                } else {
                  _this4.$message.warning('请点击生成标签');
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 生成标签
    onCreateOutBoxBarcode_OuterBoxLabelManagement: function onCreateOutBoxBarcode_OuterBoxLabelManagement() {
      this.$refs.EditTable.handleCreateOutBoxBarcode(this.TabelHeaderData);
    },
    // 设置表头数据
    setTabelHeaderData: function setTabelHeaderData(data) {
      var _this5 = this;

      this.TabelHeaderData = data;
      this.$nextTick(function () {
        _this5.$refs.TabelHeader.setFormData(data);

        _this5.$refs.EditTable.GetPartBarcodeDetailList(data);
      });
    },
    // 送货单dialog确定
    onDialogSubmit_OuterBoxLabelManagement: function onDialogSubmit_OuterBoxLabelManagement(selectRecords) {
      this.$refs.TabelHeader.setFormData(selectRecords);
    },
    // 选择送货单
    onSelectOrder_OuterBoxLabelManagement: function onSelectOrder_OuterBoxLabelManagement() {
      this.$refs.EditTable.ShowChangeOrderDialog();
    },
    // 保存
    onSave_OuterBoxLabelManagement: function onSave_OuterBoxLabelManagement() {
      this.$refs.TabelHeader.saveData();
    }
  },
  watch: {
    $DeliveryCodeOrderState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.TabelHeaderData = null;
          this.isShowTabelHeader = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.TabelHeaderData = null;
          this.isShowTabelHeader = true;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowTabelHeader = true;
        } else if (nawValue === 'editOrder') {}
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DeliveryCodeOrderState']))
};